export default __webpack_public_path__ + "static/article-christmas-gift-ideas-e0ea7c3bc261034749a0cf707568b66a.jpg";